export const formatDate = (date: string, format: 'full' | 'long' | 'short' = 'short') => {
  const parsedDate =  Date.parse(date);

  // Check if the parsedDate is NaN, which indicates an invalid date.
  if (isNaN(parsedDate)) {
    return date; // Return the input date as is.
  }

  return new Intl.DateTimeFormat(undefined, { dateStyle: format }).format(parsedDate);
}